var grey = {
  10: '#F7F7F7',
  20: '#F9FAFB',
  30: '#F5F7F9',
  40: '#E4E6E7',
  45: '#B9BEC4',
  50: '#A8ACB1',
  60: '#888B93',
  70: '#65666A',
  75: '#2B2D31',
  80: '#222529',
  90: '#181A1D'
};

export { grey };
//# sourceMappingURL=grey.esm.js.map
